import dayjs from 'dayjs'

export function money(value) {
  const num = Number(value || 0)
  return num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

// 滞销天数：购买时间到当前时间的天数
export function stagnantDays(purchaseDate) {
  if (!purchaseDate) return null
  const days = dayjs().startOf('day').diff(dayjs(purchaseDate).startOf('day'), 'day')
  return days < 0 ? 0 : days
}

export function statusText(status) {
  if (status === 0) return '库存中'
  if (status === 1) return '已卖出'
  if (status === 2) return '已退货/取消'
  return '未知'
}

export function statusTag(status) {
  if (status === 0) return 'success'
  if (status === 1) return 'info'
  if (status === 2) return 'warning'
  return 'danger'
}
